import { LoggingService } from 'src/features/common/services/logging-service';
import { request } from './request';
import { getBrowserName, getOSName } from 'src/helpers/browser';
import { Environment } from 'src/Environment';
import { Application } from 'src/features/common';
import { getCurrentStep, getLoggingTraceId } from 'src/helpers/logging';
import { getJourneyNameFromSessionStorage } from 'src/utils/SessionStorage/GetJourneyNameFromSessionStorage';

export async function getSuburbs(
  application: Application | undefined,
  postalCode: string,
  abortController?: AbortController,
  handleErrorResponse?: (errorMessage: string, errorDetails: any) => void,
): Promise<string[] | undefined> {
  const loggingService = new LoggingService();

  const startTime = performance.now();
  const res = await request(
    `suburbs?postalCode=${postalCode}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    false,
    true,
  );

  const isAborted = !!abortController && abortController.signal.aborted;

  // only log when application is defined
  // TODO: to be updated when adding logging to the portal
  if (application && !isAborted) {
    loggingService.info({
      traceId: getLoggingTraceId(),
      solutionType: application.solutionType,
      journey: getJourneyNameFromSessionStorage(),
      currentStep: getCurrentStep(application.steps, application.currentStepIndex),
      referenceNumber: application.referenceNumber,
      timestamp: new Date().toISOString(),
      api: {
        responseTime: (performance.now() - startTime).toFixed(),
        statusCode: res.status,
        endpoint: res.url,
        params: {
          postalCode: postalCode,
        },
        responseBody: res.result,
      },
      device: {
        platform: getOSName(navigator.userAgent),
        browserName: getBrowserName(navigator.userAgent),
      },
      url: window.location.href,
      environment: Environment.current.env,
    });
  }

  if (res?.status === 200) {
    const suburbValue = res.result?.suburb;
    return Array.isArray(suburbValue) ? suburbValue : [];
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse('error response from the suburbs GET endpoint', res);
  }
}
